import {
  type Organisation,
  type LutherAddress,
  Status,
} from '@acre/graphql'

const mockAddress: LutherAddress = {
  __typename: 'LutherAddress',
  address1: null,
  address2: null,
  address3: null,
  posttown: null,
  county: null,
  postcode: null,
  country: null,
  acre_property_id: null,
}
const organisation: Organisation = {
  __typename: 'Organisation',
  id: 'TEST_ID',
  organisation_id: 'TEST_ID',
  external_id: null,
  name: null,
  website: null,
  status: Status.Active,
  organisation_legal_form: null,
  fca_reg_no: null,
  joined_acre: null,
  first_time_access: null,
  client_portal_url: null,
  representative_of_org: null,
  representative_of: null,
  arOrganisationsMi: null,
  administered_by: null,
  paid_by: null,
  primary_address: mockAddress,
  primary_phone: null,
  complaints_address: mockAddress,
  complaints_phone: null,
  complaints_email: null,
  compliance_email: null,
  complaints_url: null,
  bank_account: null,
  users: [],
  clients: [],
  templates: [],
  fees: [],
  metadata: [],
  lender_metadata: null,
  standard_fee_options: [],
  general_email: null,
  panel_management: null,
  verification_class: null,
  note_templates: null,
  periods_settings: null,
  logo: null,
  client_portal_settings: null,
  organisation_ext_identifier: null,
  type: null,
  commission_structure: null,
  process_settings: null,
  protection_settings: null,
  referral_settings: null,
  rmar_settings: null,
  sourcing_settings: null,
}

export default organisation
